import { useUserStore } from '../stores/user';
import { useCustomerOnboardingStore } from '../stores/customerOnboarding';

export default class StateManager {
	constructor(url, module) { // TODO: add `module` parameter
		this.EntryUrl = document.location.pathname;
		this.EntryQueryUrl = document.location.search;

		if (this.EntryQueryUrl.indexOf('utm_campaign=IntLinks') > -1) {
			this.EntryUrl = this.EntryUrl.replace('/rfp/', '/konto/zapytanie/');
		}

		const entry = this.FromUrl(url || this.EntryUrl);

		let shouldReplace = false;

		if (document.referrer && entry.component === 'PublicView') {
			// Jeżeli przechodzimy z publicznej listę zleceń, to zamień wpis w historii,
			// zamiast dodawać nowy. Ale jeżeli nie ma referera, to dodaj - żeby obsłużyć
			// przeglądarkowy przycisk cofnij. Robię to tylko dla publicznej listy - tam
			// najczęściej występują problemy.
			shouldReplace = true;
		}

		// TODO: Powinno być replaceState, a nie pushState! Generuje to dużo bugów w momencie, kiedy stronie jest pierwsza.
		this.Travel(entry.component || '', entry.state || {}, shouldReplace, { PreventUrlChange: true });

		if (entry.component === 'LoginRegister') {
			const metaDescription = document.createElement('meta');
			metaDescription.setAttribute('name', 'description');
			metaDescription.setAttribute('content', 'Dostarczymy Ci nowych Klientów. Określ jaką usługę lub produkt oferujesz Klientom, a my skierujemy do Ciebie osoby, które właśnie w tym momencie ich szukają.');
			document.head.appendChild(metaDescription);
		}
	}

	TravelAction = '';

	BaseUrl = '/konto';

	CurrentState = {
		PageComponent: 'Rfp',
		state: {
			isAdmin: false,
			companyId: 0,
		},
	};

	InternalStack = [];

	CurrentStateName = '';

	EntryUrl = '';

	CurrentUrl = '';

	EntryQueryUrl = '';

	EntryQuery = '';

	TravelTarget = null;

	DataShouldSubmitCounter = 0;

	Resolve(url, fromHistory) {
		let component = url;
		let state = {};
		try {
			if (url.indexOf('|') > -1) {
				const data = component.split('|');
				component = data[0];
				state = JSON.parse(data[1]);
			}
		} catch (err) {
			let entry:any = document.location.href.replace(document.location.origin, '');
			entry = this.FromUrl(entry);
			component = entry.component;
			state = entry.state;
		}
		this.Travel(component, state, fromHistory ? 'history' : true);
	}

	ProfileSections = {
		Internal: ['BasicInfo', 'ContactInfo', 'Gallery', 'Description', 'Services', 'AdditionalServices', 'Promotion', 'Reviews', 'Offers', 'Certificates', 'Partnership'],
		External: ['informacje', 'dane-kontaktowe', 'galeria-zdjec', 'opis', 'uslugi-produkty', 'uslugi-dodatkowe', 'promowanie', 'opinie', 'oferty', 'certyfikaty', 'program-partnerski'],
		Label: ['Informacje', 'Dane kontaktowe', 'Galeria zdjęć', 'Opis', 'Usługi i produkty', 'Usługi dodatkowe', 'Opinie', 'Oferty', 'Certyfikaty', 'Program partnerski'],
	};

	SettingsSections = {
		Internal: ['Payments', 'Notifications', 'ChangePassword', 'ExpressManageCustomers'],
		External: ['saldo', 'powiadomienia', 'haslo', 'admin'],
		Label: ['Saldo', 'Powiadomienia', 'Ustawienia konta', 'Zarządzanie'],
	};

	PreviousUrl = '';

	FromUrl(url) {
		const isWithinBase = url.indexOf(this.BaseUrl) > -1;
		const qs = new URLSearchParams(document.location.search);
		url = url.replace(this.BaseUrl, '').toLowerCase() || '/';
		url = (url.split('?'))[0];
		url = url.startsWith('/') ? url.substr(1) : url;
		url = url.split('/');
		// ZRÓB: Oprzyj to na patternach.
		let component;
		let state: any = {};
		switch (url[0]) {
		case 'zaplac': component = 'InvoicePaymentPage'; break;
		case 'witaj': component = 'OnboardingPage'; break;
		case 'kontakty': component = 'Contacts'; break;
		case 'profil': component = 'CustomerProfileView'; break;
		case 'ustawienia': component = 'CustomerSettingsView'; break;
		case 'powiadomienia': component = 'PromoMessagesPage'; break;
		case 'rejestracja': component = 'LoginRegister'; state = { LoginPage: 'register' }; break;
		case 'rejestracja-dostawcy.html': component = 'LoginRegister'; state = { LoginPage: 'register' }; break;
		case 'logowanie': component = 'LoginRegister'; state = { LoginPage: 'login' }; break;
		case 'moje-zapytania': component = 'BuyerView'; break;
		case 'pomoc': component = 'QuickPaymentsPage'; break;
		case 'polecanie': component = 'RecommendationPage'; break;
		case 'promowanie': component = 'PromotionPage'; break;
		case 'debug': component = 'Debug'; break;
		case 'wystaw-opinie': component = 'ReviewFormPage'; break;
		default: component = 'Rfps';
		}

		if (url[0] === 'buyer-app') {
			// edit przy rozbudowaniu tego urla
			if (url[1] === 'auth') {
				component = 'BuyerAppAuth';
			}
			if (url[1] === 'mobile-auth') {
				component = 'BuyerAppAuth';
			}
			if (url[1] === 'rfp-list') {
				component = 'BuyerList';
				if (url[2] === 'rfp') {
					component = 'BuyerRfpDetails';
					state.RfpId = url[3];
				}
				if (url[5] === 'czat') {
					component = 'RfpChatCustomerInfo';
					state.RfpId = url[3];
					state.CustomerId = url[4];
					state.Section = 'rfp-chat';
				}
			}
			if (url[1] === 'homepage') {
				component = 'MobileBuyerAppHomepage';
			}
		}

		if (url[0] === 'terminarz') {
			component = 'SchedulerPage';
			if (url[1]) {
				state.TermId = url[1];
			}
		}

		if (url[0] === 'zaplac') {
			state = {
				InvoiceId: qs.get('paymentToken'),
				IsAutomatic: qs.get('automaticPayments'),
			};
		}

		if ((url[0] === 'zobacz' || url[0] === 'rfp') && !isWithinBase) {
			component = 'PublicView';
			state = { Public: false, RfpId: url[1] ? (url[1].split('_')[0]) : '', AutoUncover: (url[2] === 'odkryj' || this.EntryQueryUrl.indexOf('doUncover') > -1) };
		}

		if (url[0] === 'moje-zapytania') {
			if (!url[1]) {
				component = 'BuyerList';
			} else if (url[1] === 'profil') {
				component = 'BuyerProfile';
				if (url[2] === 'ustaw-haslo') {
					state.Section = 'change-password';
				}
				if (url[2] === 'powiadomienia') {
					state.Section = 'notifications-settings';
				}
			} else if (url[1] === 'order') {
				component = 'BuyerExpressOrderDetails';
				state.id = url[2];
			} else if (url[2]) {
				component = 'BuyerRfpDetails';
				state.RfpId = Number(url[2]);
				if (url[3]) {
					component = 'RfpChatCustomerInfo';
					state.CustomerId = Number(url[3]);
					state.Section = url[4] === 'informacje' ? 'rfp-customer-info' : 'rfp-chat';
				}
			}
		}

		if (url[0] === 'formularz') {
			component = 'Form';
			let params = url.length > 1 ? url.join('/').replace('formularz/', '') : '';
			params = document.location.search.substr(1);
			state = { InitialParams: params };
		}

		if (url[0] === 'zapytania' || url[0] === 'kontakty') {
			state = { List: url[0] === 'zapytania' ? 'Rfps' : 'Contacts' };
			if (url[1] && url[1].startsWith('filtruj')) { state.FilterQuery = url[2]; }
		}

		if (url[0] === 'zapytanie') {
			state = { List: 'Rfps' };

			if (url[2] === 'odkryj') {
				state.AutoUncover = true;
			}

			if (url[1] === 'czat') {
				state.RfpId = url[2];
				state.ChatMode = true;
			} else {
				state.RfpId = url[1].split('_').shift();
			}
		}

		if (url[0] === 'profil' && url[1]) {
			const n = this.ProfileSections.External.indexOf(url[1]);
			state.Section = this.ProfileSections.Internal[n];
			if (url[1] === 'oferty' && url[2]) {
				if (url[2] === 'nowa') { url[2] = -1; }
				state.SelectedId = url[2];
			}
			if (url[1] === 'opinie' && url[2] === 'wyslij') {
				state.AskForReviewsOnLoad = true;
			}
			if (url[1] === 'certyfikaty' && url[2]) {
				switch (url[2]) {
				case 'sprawdzona-firma': state.SelectedSectionId = 'verified'; break;
				case 'polecaja-nas': state.SelectedSectionId = 'recommended'; break;
				case 'profesjonalny-sprzedawca': state.SelectedSectionId = 'professional'; break;
				case 'ekspert-oferteo': state.SelectedSectionId = 'expert'; break;
				case 'promuj-firme': state.SelectedSectionId = 'widgets'; break;
				case 'najlepsi': state.SelectedSectionId = 'badges'; break;
				case 'odznaki': state.SelectedSectionId = 'badges'; break;
				case 'naklejki': state.ShowCertificatesBadgesSticker = true; state.SelectedSectionId = 'badges'; break;
				default: break;
				}
				if (url[2] === 'odznaki' && url[3] && url[3] === 'modal') {
					state.AutoDisplay = true;
				}
			}
			if (url[1] === 'uslugi-produkty' || url[1] === 'uslugi-dodatkowe') {
				state.DisplayAdditionalFilters = url[1] === 'uslugi-dodatkowe';
			}
		}

		if (url[0] === 'ustawienia' && url[1]) {
			const n = this.SettingsSections.External.indexOf(url[1]);
			state.Section = this.SettingsSections.Internal[n];

			if (url[1] === 'historia-operacji') {
				state.Section = 'Payments';
				state.HistoryPageType = 'History';
			}
			if (url[1] === 'faktury') {
				state.Section = 'Payments';
				state.HistoryPageType = 'Invoices';
			}
			if (url[1] === 'admin') {
				state.CustomerId = url[2];
			}
		}

		if (url[0] === 'buyer-app-profile' || url[1] === 'buyer-app-profile') {
			component = 'BuyerAppProfile';
			state.BuyerApp = 'Profile';
		}

		if (url[0] === 'buyer-app-contest' || url[1] === 'buyer-app-contest') {
			component = 'BuyerAppContestPage';
			state.BuyerApp = 'Contest';
		}

		if (url[0] === 'logowanie') {
			component = 'LoginRegister';
			if (url[2] && url[2].indexOf('ack=') > -1) {
				component = 'BuyerAppAuth';
				state = { LoginPage: 'buyer-app-auth', BuyerAppAuth: 'buyer-app-mail-complete' };
				return { url, component, state };
			}
			state = { LoginPage: url[1] === 'buyer-app-auth' ? 'buyer-app-auth' : 'login' };
			if (window.localStorage.getItem('isBuyerApp') === 'true') {
				// dla przekierowań typu przypomnij hasło
				state = { LoginPage: 'buyer-app-auth' };
			}
		}

		if (url[0] === 'wystaw-opinie') {
			if (url[1] === 'aktywuj') {
				state.isPreview = true;
				state.ReviewId = Number(url[2]);
				if (url[3]) {
					state.Ack = url[3];
				}
			} else {
				component = 'ReviewFormPage';
				state.PageComponent = 'ReviewFormPage';
				state.CustomerId = Number(url[1]);
				state.SourceId = url[2];
				if (url[3]) {
					state.RfpId = Number(url[3]);
				}
			}
		}

		return { url, component, state };
	}

	ToUrl(component, state) {
		const r = [this.BaseUrl];
		let title = '';
		component = component || this.CurrentStateName;

		if (component === 'Rfps' || component === 'Contacts') {
			if (state.RfpId) {
				r.push('zapytanie');
				r.push(`${state.RfpId}_`);
				if (state.QueryParams) {
					r.push(`?${new URLSearchParams(state.QueryParams).toString()}`);
				}
				title = 'Zapytanie ofertowe';
			} else {
				r.push((state.List || component) === 'Rfps' ? 'zapytania' : 'kontakty');
				if (state.FilterQuery) {
					r.push('filtruj');
					r.push(state.FilterQuery);
				}
				title = (state.List || component) === 'Rfps' ? 'Zapytania' : 'Kontakty';
			}
		}

		if (component === 'CustomerProfileView' || component === 'CustomerSettingsView' || component === 'Settings' || component === 'Profile') {
			if (component === 'CustomerProfileView') { component = 'Profile'; }
			if (component === 'CustomerSettingsView') { component = 'Settings'; }

			r.push(component === 'Profile' ? 'profil' : 'ustawienia');
			title = component === 'Profile' ? 'Profil' : 'Ustawienia';

			if (state.Section === 'Payments' && state.HistoryPageType) {
				r.push(state.HistoryPageType === 'History' ? 'historia-operacji' : 'faktury');
			} else if (state.Section) {
				const sl = this[`${component}Sections`];
				const n = sl.Internal.indexOf(state.Section);
				r.push(sl.External[n]);
				// 3SsDRac4bRrP3XqTuSPfHuiXn2yzjghe
				if (sl.Label[n]) {
					title = `${title} › ${sl.Label[n]}`;
				}
				if (state.Section === 'Certificates' && state.SelectedSectionId && state.ShowCertificatesBadgesSticker) {
					r.push('naklejki');
				} else if (state.Section === 'Certificates' && state.SelectedSectionId) {
					const z = {
						verified: 'sprawdzona-firma',
						recommended: 'polecaja-nas',
						professional: 'profesjonalny-sprzedawca',
						expert: 'ekspert-oferteo',
						widgets: 'promuj-firme',
						badges: 'odznaki',
					};
					r.push(z[state.SelectedSectionId] || 'szczegoly');
					if (state.AutoDisplay) { r.push('modal'); }
					if (state.SelectedSectionId === 'badges') {
						title = 'Ranking Najlepszych';
					}
				}
			}

			if (state.Section === 'ExpressManageCustomers') {
				r.push(state.CustomerId);
			}

			if (state.Section === 'Promotion') {
				title = 'Profil > Promowanie';
			}
		}

		if (component === 'SchedulerPage') {
			title = 'Terminarz';
			r.push('terminarz');
			if (state?.SelectedEvent) {
				r.push(state.SelectedEvent);
			}
		}

		let url = r.join('/');

		if (component === 'QuickPaymentsPage') {
			title = 'Jak działa Szybkie Doładowanie?';
			url = '/konto/pomoc/szybkie-doladowanie';
		}

		if (component === 'RecommendationPage') {
			title = 'Jak działa Polecanie?';
			url = '/konto/polecanie';
		}

		if (component === 'OnboardingPage') {
			title = 'Witamy w Oferteo';
		}

		if (component === 'PromoMessagesPage') {
			title = 'Powiadomienia';
		}

		if (component === 'BuyerMessagesPage') {
			title = 'Powiadomienia';
			url = state.Url;
		}

		if (component === 'LoginRegister' && (!state.LoginPage || state.LoginPage === 'register')) {
			title = 'Rejestracja';
			url = `/rejestracja/wybierz-klientow${this.EntryQueryUrl || ''}`;
		}

		if (component === 'LoginRegister' && (state.LoginPage === 'login')) {
			title = 'Logowanie';
			url = '/logowanie';
		}

		if (component === 'LoginRegister' && (state.LoginPage === 'buyer-app-auth')) {
			title = 'Logowanie';
			url = '/buyer-app/auth';
		}

		if (component === 'PublicView') {
			title = 'Zapytanie ofertowe';
			url = `/rfp/${state.RfpId}_`;
		}

		if (component === 'BuyerList') {
			if (window.localStorage.getItem('isBuyerApp') === 'true') {
				url = '/buyer-app/rfp-list';
			} else {
				url = '/konto/moje-zapytania';
			}
			title = 'Moje zapytania';
		}

		if (component === 'BuyerRfpDetails') {
			if (window.localStorage.getItem('isBuyerApp') === 'true') {
				url = `/buyer-app/rfp-list/rfp/${state.RfpId}`;
			} else {
				url = `/konto/moje-zapytania/rfp/${state.RfpId}`;
			}

			// url = `/konto/moje-zapytania/rfp/${state.RfpId}`;
			title = 'Zainteresowane firmy';
		}

		if (component === 'BuyerExpressOrderDetails') {
			url = `/konto/moje-zapytania/order/${state.id}`;
			title = 'Szczegóły rezerwacji';
		}

		if (component === 'BuyerProfile') {
			url = '/konto/moje-zapytania/profil';
			title = 'Moje zapytania';
		}

		if (component === 'BuyerAppProfile') {
			url = '/konto/buyer-app-profile';
			title = 'Profil';
		}

		if (component === 'RfpChatCustomerInfo') {
			if (window.localStorage.getItem('isBuyerApp') === 'true') {
				url = '/buyer-app/rfp-list/rfp';
			} else {
				url = '/moje-zapytania/rfp';
			}

			if (state.RfpId) {
				url += `/${state.RfpId}`;
			}
			if (state.CustomerId) {
				url += `/${state.CustomerId}`;
			}

			if (state.Section === 'rfp-customer-info') {
				title = 'Informacje o firmie';
				url += '/informacje';
			} else {
				title = 'Rozmawiaj ze Specjalistą';
				url += '/czat';
			}

			// bug z przekierowaniem na liste rfp
			if (localStorage.getItem('isBuyerApp') === 'true') {
				if (!state.RfpId && !state.CustomerId) {
					window.location.href = '/buyer-app/rfp-list';
				}
			}
		}

		if (component === 'InvoicePaymentPage') {
			title = 'Płatność za fakturę';
			url = `/konto/zaplac?paymentToken=${state.InvoiceId}`;
		}

		if (component === 'Form') {
			title = 'Formularz ofertowy';
			url = `/formularz/${state.InitialParams ? (`?${state.InitialParams}`) : ''}`;
		}

		if (component === 'BuyerAppContestPage') {
			title = 'Konkurs';
			url = '/buyer-app-contest';
		}

		if (component === 'MobileBuyerAppHomepage') {
			title = 'Strona główna';
			url = '/buyer-app/homepage';
		}

		if (component === 'BuyerAppAuth') {
			title = 'Logowanie';
			url = '/buyer-app/auth';
		}
		if (component === 'BuyerAppAuth') {
			title = 'Logowanie';
			url = '/buyer-app/mobile-auth';
		}
		if (component === 'ReviewFormPage') {
			title = 'Dodaj opinię o specjaliście';
		}

		return { url, title };
	}

	async Logout() {
		// LoggedAs ustawiane jest w ServerManager.ts
		const userStore = useUserStore();
		await fetch(userStore.loggedAs ? '/j_acegi_exit_user' : '/j_acegi_logout');
		document.location.href = '/';
	}

	ChangeWindowTitle(title, url?) {
		if (title && title !== 'Zapytanie ofertowe') { document.title = `${title} – Oferteo.pl`; }
		if (url) {
			let i = this.InternalStack.length; i = i ? i - 1 : 0;
			window.history.replaceState(this.InternalStack[i], '', url);
		}
	}

	PeekAndReplace(replacer, deep = -1) {
		const d = this.InternalStack.length - deep;
		const r = this.InternalStack[d];
		if (r) {
			this.InternalStack[d] = replacer(r);
		}
	}

	Peek(deep = -1) {
		try {
			let r = this.InternalStack[this.InternalStack.length - deep];
			if (!r) { return null; }
			r = r.indexOf('|') === -1 ? [r, '{}'] : r.split('|');
			return {
				Name: r[0],
				State: JSON.parse(r[1]),
			};
		} catch (err) { return {}; }
	}

	ShouldScrollTop(n, p) {
		if (n.Name) { return true; }
		if (p) {
			if (n.State.Section !== -1 && p.State.Section && p.State.Section !== n.State.Section) { return true; }
			if (p.State.RfpId !== n.State.RfpId) { return true; }
			if (p.Name && n.Name && p.Name !== n.Name) { return true; }
		}
		return false;
	}

	Previous(deep = 1) {
		const internal = this.InternalStack;
		const previous = internal[internal.length - 1 - deep] as string;
		if (!previous) { return {}; }

		const previousState = previous.split('|')[1];
		if (!previousState) { return {}; }

		try {
			return JSON.parse(previousState);
		} catch (err) {
			return {};
		}
	}

	Append(state, replace = false) {
		this.Travel(null, { ...this.CurrentState.state, ...state }, replace);
	}

	BeforeTravel(component, state, replace) {
		const prev = this.Previous();
		const current = this.CurrentState;
		const differentSection = state && current.state && current.state.Section !== state.Section;
		const travel = replace !== 'fromHistory';
		const shouldDisplaySaveChanges = (prev.DataShouldSubmit && current.PageComponent === 'CustomerProfileView') && (component !== 'CustomerProfileView' || differentSection) && travel;
		const cropPhotoModal = (state && state.CropPhotoModal) || (prev && prev.CropPhotoModal);
		const workHoursDialog = (state && state.workHoursDialog) || (prev && prev.workHoursDialog);

		if (shouldDisplaySaveChanges && !this.TravelTarget && !cropPhotoModal && !workHoursDialog) {
			this.TravelTarget = [...arguments];
			window.history.back();
			return false;
		}

		if (replace === 'history' && state && state.DataShouldSubmit === true) {
			this.DataShouldSubmitCounter++;
		}

		if (this.DataShouldSubmitCounter > 1) {
			this.DataShouldSubmitCounter = 0;
			if (this.TravelTarget) {
				this.TravelTarget[1].DataShouldSubmit = false;
				this.Travel(this.TravelTarget[0], this.TravelTarget[1], true);
			}
			return false;
		}

		return true;
	}

	Act(action:string, module:string, newWindow:boolean) {
		const isPublic = module !== 'CustomerView'; // TODO: Będzie trzeba rozwiązać kwestię przechodzenia pomiędzy modułami.

		switch (action) {
		case 'HomePage': document.location.href = '/'; break;
		case 'MobileBuyerAppHomepage': document.location.href = '/buyer-app/homepage'; break;
		case 'NewForm': document.location.href = '/znajdz-specjalistow'; break;
		case 'Rfps': if (isPublic) { document.location.href = '/konto/zapytania'; } else { this.Travel('Rfps'); } break;
		case 'Contacts': if (isPublic) { document.location.href = '/konto/kontakty'; } else { this.Travel('Contacts'); } break;
		case 'Scheduler': this.Travel('Scheduler'); break;
		case 'Services': document.location.href = '/konto/profil/uslugi-produkty'; break;
		case 'Promotion': document.location.href = '/konto/profil/promowanie'; break;
		case 'MyRfps': document.location.href = '/rfp/moje-zapytania.ofer'; break;
		case 'BuyerView': document.location.href = '/rfp/moje-zapytania.ofer'; break;
		case 'CustomerView': document.location.href = '/konto/'; break;
		case 'Payments': if (isPublic) { document.location.href = '/konto/ustawienia/saldo'; } else { this.Travel('Settings'); } break;
		case 'ReportError': document.location.href = '/kontakt.html?idSubject=contactError'; break;
		case 'Partnership': document.location.href = '/konto/profil/program-partnerski'; break;
		case 'Register': document.location.href = '/rejestracja/wybierz-klientow'; break;
		case 'SetUserData': document.location.href = '/rfp/dane-kontaktowe.ofer'; break;
		case 'SetPassword': document.location.href = '/rfp/ustaw-haslo.ofer'; break;
		case 'DisplayNps': window.setTimeout(() => { this.Travel(null, { ...this.CurrentState, NpsSurveyPage: 'Hello' }); }, 150); break;
		case 'DisplayAppSurvey': window.setTimeout(() => { this.Append({ AppSurveyPage: 'Hello' }); }, 150); break;
		case 'Logout': this.Logout(); break;
		default:
			if (newWindow) {
				window.open(action);
			} else {
				document.location.href = action;
			}
		}
	}

	GoToAutenti() {
		this.EntryUrl = document.location.pathname;
		const onboardingStore = useCustomerOnboardingStore();
		onboardingStore.needsVerification = true;
		this.Travel('OnboardingPage');
	}

	Travel(component:string, state: any = {}, replace: boolean | string = false, options: any = {}) {
		if (!this.BeforeTravel(...arguments)) { return; }

		let goTo = '';
		if (component === 'HomePage') { goTo = '/'; }
		if (component === 'HomePageBuyerApp') { goTo = '/?oferteoBuyerApp=true'; }
		if (component === 'Services') { goTo = '/konto/profil/uslugi-produkty'; }
		if (goTo) {
			document.location.href = goTo; return;
		}

		// dont use replace, use options
		if (replace === 'stay-scroll' && state.Scroll) {
			window.setTimeout(() => { window.scrollTo(0, state.Scroll); }, 150);
		} else if (replace !== 'history') {
			const shouldScroll = this.ShouldScrollTop({ Name: component, State: state }, this.Peek());
			if (shouldScroll) {
				window.scrollTo(0, 0);
				// ustaw state.Scroll
			}
		} else if (state.Scroll) {
			// State ma scrolla.
			if ((this.CurrentState.state || {} as any).RfpId && !state.RfpId && (['Rfps', 'Contacts'].indexOf(component) > -1)) {
				window.setTimeout(() => { window.scroll(0, state.Scroll); }, 150);
			}
		}

		if (!component) { component = this.CurrentStateName; }
		const historyMethod = replace ? 'replaceState' : 'pushState';
		const url = component + (Object.keys(state).length ? `|${JSON.stringify(state)}` : '');

		let defaults = this.Defaults[component];
		if (!defaults) { defaults = { PageComponent: component }; }
		this.CurrentState = { ...defaults, state };
		this.CurrentStateName = component;

		const toUrl = this.ToUrl(component, state);
		if (toUrl.url.endsWith('_')) { options.PreventUrlChange = true; }

		// obejscie dla buga zwiazanego z brakiem przekierowanai na poprzednia strone po odswiezeniu
		if (toUrl.url.indexOf('/konto/moje-zapytania/rfp/undefined') > -1) {
			window.location.href = '/konto/moje-zapytania';
		}
		// obejscie dla buga zwiazanego z brakiem przekierowanai na poprzednia strone po potwierdzeniu zapytania
		if (toUrl.url.indexOf('/buyer-app/rfp-list/rfp/undefined') > -1) {
			window.location.href = '/buyer-app/rfp-list';
		}

		// Aby uniknąć konfliktu podczas przemieszczania się na strony korzystające z Vue Routera:
		// w innym przypadku po kliknięciu przycisku wstecz w przeglądarce następuje jeden pusty przebieg,
		// ponieważ wykonujemy dodatkowy przeskok w kontruktorze tej klasy.
		const toVueRouter = (component === 'CustomerProfileView'
			&& (state.Section === 'Services' || state.Section === 'Promotion')) || component === 'ReviewFormPage';
		if (!toVueRouter) {
			window.history[historyMethod](url, '', options.PreventUrlChange ? '' : toUrl.url);
		}

		if (toUrl.url !== this.PreviousUrl) {
			this.SetContentGroup(component, state, toUrl.url);
			this.PreviousUrl = toUrl.url;
		}

		this.CurrentUrl = toUrl.url;

		window.setTimeout(() => {
			this.ChangeWindowTitle(toUrl.title);
		}, 150);

		if (replace) {
			let i = this.InternalStack.length; i = i ? i - 1 : 0;
			this.InternalStack[i] = url;
		} else {
			this.InternalStack.push(url);
		}
	}

	SetContentGroup(component, state, url) {
		if (!window.Analytics) { return; }

		// Wyślij typ strony do analityki.
		const gtmPageType = window.Analytics.GtmPageType(window.MODULE, component, state);
		const isBuyerApp = window.localStorage.getItem('isBuyerApp') === 'true';
		window.Analytics.GtmDims({ page_type: gtmPageType, is_buyer_app: isBuyerApp });

		if (state.RfpId) { return; } // TODO: Dane z podglądu zapytania (czyl jeśli istnieje RfpId) powinny być obsługiwane w RfpDetails, bo nie mamy części informacji.
		let pageType = '';
		if (component === 'Rfps') { pageType = 'RfpSearchMyOferteo'; }
		if (component === 'Contacts') { pageType = 'ContactsMyOferteo'; }
		if (component === 'CustomerProfileView') { pageType = 'ProfileMyOferteo'; }
		if (component === 'CustomerSettingsView') { pageType = 'SettingsMyOferteo'; }
		if (component === 'LoginRegister') { pageType = 'CustRegSearchCat'; }
		if (component === 'Form') { pageType = 'RfpFormModal'; }
	}

	Back() {
		// Łatka przy w chodzeniu z maila, do poprawy.
		const ref = document.referrer;
		if (ref && ref.indexOf('?popros-o-opinie') > -1 && this.InternalStack.length === 1) {
			document.location.href = '/konto/profil/';
		} else if (this.InternalStack.length === 1) {
			this.Travel(null, {});
		} else {
			window.history.back();
		}
	}

	Defaults = {
		MobileBuyerAppPanel: { PageComponent: 'MobileBuyerAppPanel' },
		Rfps: { PageComponent: 'RfpPage', List: 'Rfps' },
		Contacts: { PageComponent: 'RfpPage', List: 'Contacts' },
		Profile: { PageComponent: 'CustomerProfileView', Section: '' },
		Services: { PageComponent: 'CustomerProfileView', Section: 'Services' },
		Settings: { PageComponent: 'CustomerSettingsView' },
	};
}
